<template>
<span>
  <template v-if="orderHistory && orderHistory.length">
    <v-layout row wrap>
      <v-flex>
        <v-expansion-panel style="padding: 10px;">
          <template v-for="(order, index) in orderHistory">
            <FetchData :fetch="() => fetchItem(order)" v-slot:default="{ response, loading }">
              <order-history-item
                v-if="!loading && response"
                :key="`order_history_${index}`"
                :order="response.data"
                :expanded="expandedOrders[response.data.orderId] || false"
                @expand="toggleExpand(response.data.orderId)"
              />
            </FetchData>
          </template>
        </v-expansion-panel>
      </v-flex>
    </v-layout>
  </template>
  <template v-else>
    <div class="headline my-3">
      {{
        orderHistory === null
          ? $vuetify.t('$vuetify.common.loading')
          : $vuetify.t('$vuetify.account.noOrderHistory')
      }}
    </div>
  </template>
</span>
</template>

<script>
  import { mapGetters, mapMutations, mapActions } from 'vuex'
  import get from "lodash/get";

  import OrderHistoryItem from '@/components/Account/OrderHistoryItem.vue'
  import FetchData from '@/components/Common/FetchData.vue'

  export default {
    components: {
      OrderHistoryItem,
      FetchData
    },

    data() {
      return {
        orderHistory: null,
        expandedOrders: {}
      }
    },
    computed: {
      ...mapGetters([
        'getStore',
        'getOrder',
        'getAuthToken'
      ])
    },

    methods: {
      fetchItem(orderId) {
        let config = {
          headers: {
            storeId: this.getStore.storeId
          }
        }

        return this.$api.get(`/order/${orderId}`, config).then(res => {
          this.ADD_ORDER(res.data)
          return res
        }).catch(e => {
          const text = get(e, 'response.data.errorMsg', '')
          const payload = { text, color: 'error' }
          this.$store.dispatch('showSnack', payload)
        })
      },
      toggleExpand(orderId) {
        this.$set(this.expandedOrders, orderId, !this.expandedOrders[orderId]);
      },

      ...mapMutations(['ADD_ORDER'])
    },

    mounted() {
      const guestOrderHistory = JSON.parse(localStorage.getItem('guestOrderHistory')) || {}
      this.orderHistory = guestOrderHistory[this.getStore.storeId]//.map(item => {return {storeId: item}}) || []
    }
  }
</script>
